import { rechargeApiRequest } from '../utils/request.js';
async function getCustomer(session, options) {
  const id = session.customerId;
  if (!id) {
    throw new Error("Not logged in.");
  }
  const {
    customer
  } = await rechargeApiRequest("get", `/customers`, {
    id,
    query: {
      include: options?.include
    }
  }, session);
  return customer;
}
async function updateCustomer(session, updateRequest) {
  const id = session.customerId;
  if (!id) {
    throw new Error("Not logged in.");
  }
  const {
    customer
  } = await rechargeApiRequest("put", `/customers`, {
    id,
    data: updateRequest
  }, session);
  return customer;
}
async function getDeliverySchedule(session, query) {
  const id = session.customerId;
  if (!id) {
    throw new Error("Not logged in.");
  }
  const {
    deliveries
  } = await rechargeApiRequest("get", `/customers/${id}/delivery_schedule`, {
    query
  }, session);
  return deliveries;
}
async function getCustomerPortalAccess(session) {
  return rechargeApiRequest("get", "/portal_access", {}, session);
}
async function getActiveChurnLandingPageURL(session, subscriptionId, redirectURL) {
  const {
    base_url,
    customer_hash,
    temp_token
  } = await getCustomerPortalAccess(session);
  return `${base_url.replace("portal", "pages")}${customer_hash}/subscriptions/${subscriptionId}/cancel?token=${temp_token}&subscription=${subscriptionId}&redirect_to=${redirectURL}`;
}
async function getGiftRedemptionLandingPageURL(session, giftId, redirectURL) {
  const {
    base_url,
    customer_hash,
    temp_token
  } = await getCustomerPortalAccess(session);
  return `${base_url.replace("portal", "pages")}${customer_hash}/gifts/${giftId}?token=${temp_token}&redirect_to=${redirectURL}`;
}
const customerNotificationMap = {
  SHOPIFY_UPDATE_PAYMENT_INFO: {
    type: "email",
    template_type: "shopify_update_payment_information"
  }
};
async function sendCustomerNotification(session, notification, options) {
  const customerId = session.customerId;
  if (!customerId) {
    throw new Error("Not logged in.");
  }
  const data = customerNotificationMap[notification];
  if (!data) {
    throw new Error("Notification not supported.");
  }
  return rechargeApiRequest("post", `/customers/${customerId}/notifications`, {
    data: {
      ...data,
      template_vars: options
    }
  }, session);
}
async function getCreditSummary(session, options) {
  const id = session.customerId;
  if (!id) {
    throw new Error("Not logged in.");
  }
  const {
    credit_summary
  } = await rechargeApiRequest("get", `/customers/${id}/credit_summary`, {
    query: {
      include: options?.include
    }
  }, session);
  return credit_summary;
}
export { getActiveChurnLandingPageURL, getCreditSummary, getCustomer, getCustomerPortalAccess, getDeliverySchedule, getGiftRedemptionLandingPageURL, sendCustomerNotification, updateCustomer };